import { pickThemeFontStyles } from '@/theme';
import { Pagination } from '@/ui';
import styled, { createGlobalStyle } from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 2rem;
`;

export const StyledButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
`;

export const StyledMessage = styled.p``;

export const StyledPagination = styled(Pagination)`
  margin-inline: auto;
`;

export const StyledSearchWrapper = styled.div`
  max-width: 40%;
  margin-bottom: 1rem;
`;

export const StyledTableHeader = styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 1rem;

  p {
    margin: 0;
    ${pickThemeFontStyles('16', '20')}
  }
`;

export const PopoverOverlayGlobalStyles = createGlobalStyle`
.bulk-delete-popover {
  .ant-popover-content {
    .ant-popover-inner {
      padding: 0.5rem 1rem;
      border-radius: 0.325rem;

      .ant-popover-title {
        text-align:center;
        margin: 0;
      }
    }
  }
}
`;
